import React from 'react';

interface IAppImage {
  dataId: string;
  imageSrc: string;
}
export const AppImage = ({ dataId, imageSrc }: IAppImage) => (
  <img data-id={dataId} src={imageSrc} alt="Origin app" height="400" />
);
